import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IDataSourceDetailInfo } from '../../../datasource/models/IDataSourceInfo';
import { EntityActionNames, IEntityAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isVisibleOnEncryptionAction } from '../../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IEncryptAction } from '../../../spacesPlatform/models/actionNames';
import { encryptContent, EncryptionActionType } from '../../actions/encryptContent/EncryptContentAction';

export const EncryptAction: IEntityAction<IContentInfo, IEncryptAction> = {
  name: EntityActionNames.Encrypt,
  translateName: Messages.encrypt_action,
  isVisible: (targetItems: IContentInfo[], state: AppState) => {
    return isVisibleOnEncryptionAction(targetItems as IDataSourceDetailInfo[], state);
  },
  isClickable: (availableActions: IEncryptAction, targetItems: IContentInfo[]) => {
    return targetItems.length > 1 || !!(availableActions && availableActions.encryptExtracts);
  },
  createReduxAction: (targetItems: IContentInfo[]) => encryptContent(targetItems, EncryptionActionType.encryptExtracts)
};
